import script from "./RestockVariants.vue?vue&type=script&setup=true&lang=js"
export * from "./RestockVariants.vue?vue&type=script&setup=true&lang=js"

import "./RestockVariants.vue?vue&type=style&index=0&id=67d5f9d4&lang=css"

const __exports__ = script;

export default __exports__